import { render } from "./ServiceCard.vue?vue&type=template&id=2e70f866&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"

import "./ServiceCard.vue?vue&type=style&index=0&id=2e70f866&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e70f866"]])

export default __exports__